import React from 'react';
import { motion } from 'framer-motion';

export default function HeroTitle() {
  return (
    <div className="relative mb-12">
      {/* Decorative glow */}
      <div className="absolute -inset-x-4 -inset-y-2">
        <div className="w-full h-full bg-red-600/5 blur-2xl rounded-full" />
      </div>

      {/* Main title */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative"
      >
        <h1 className="text-left">
          <span className="block text-6xl md:text-8xl font-black text-red-700 font-serif italic leading-tight">
            Benny's
          </span>
          <span className="block text-5xl md:text-7xl font-black text-gray-900 tracking-tight">
            Pølsevogn
          </span>
        </h1>
      </motion.div>

      {/* Decorative line */}
      <div className="absolute left-0 right-0 bottom-0 pointer-events-none">
        <div className="h-px bg-gradient-to-r from-red-700/20 to-transparent" />
      </div>
    </div>
  );
}